/**
 * Function that filters categories based on the given group / facility name.
 * - eg. "Chemicals and Additives" from "Vinimark Trading"
 * - "Shipping Distribution" and "Inter-DC Distribution" from "Reyneke Wines" or "Twee Jonge Gezellen"
 * - All "Distributions" from Head Office
 * @param {Array<string>} categories 
 * @param {string} name 
 * @param {"facility" | "group"} type 
 * @returns {Array<string>}
 */
export function filterCategoriesForSpecialCases(categories, name, type) {
    const isFacility = type === 'facility'
    const isGroup = type === 'group'
    if (name === 'Twee Jonge Gezellen' && isFacility) {
        const categoriesToExclude = [
            'Inter-DC Distribution',
            'Shipping Distribution'
        ]
        const filteredCategories = categories.filter((category) => (!categoriesToExclude.includes(category)))
        return filteredCategories
    }
    if (name === 'Robertson Winery' && isFacility) {
        const categoriesToExclude = [
            'Agrochemicals Applied',
            'Fertilizer Applied',
        ]
        const filteredCategories = categories.filter((category) => (!categoriesToExclude.includes(category)))
        return filteredCategories
    }
    if (name === 'Reyneke Wines' && isFacility) {
        const categoriesToExclude = [
            'Agrochemicals Applied',
            'Fertilizer Applied',
            'Inter-DC Distribution',
            'Shipping Distribution'
        ]
        const filteredCategories = categories.filter((category) => (!categoriesToExclude.includes(category)))
        return filteredCategories
    }
    if (name === 'Vinimark Trading' && isGroup) {
        const categoriesToExclude = [
            'Dry Ice',
            'Fertilizer Applied',
            'Agrochemicals Applied',
            'Farm-DC Distribution',
            'Chemicals and Additives',
            'Waste to Biochar Production'
        ]
        const filteredCategories = categories.filter((category) => (!categoriesToExclude.includes(category)))
        return filteredCategories
    }
    if (name === 'Head Office' && isFacility) {
        // Facility, exclude all distributions
        const categoriesToExclude = categories.filter((category) => category.includes('Distribution'));
        const filteredCategories = categories.filter((category) => (!categoriesToExclude.includes(category)));
        return filteredCategories
    }
    else return categories
}

/**
 * Pairs filtering logic, since filters could be applied on a group or facility level
 * @param {Array<string>} categories
 * @param {string} groupName 
 * @param {string} facilityName 
 * @returns {string[]} Filtered array that will exclude the categories not associated with them.
 */
export function filterCategoriesByGroupAndFacility(categories, groupName, facilityName) {
    const groupFilter = filterCategoriesForSpecialCases(categories, groupName, 'group')
    const facilityFilter = filterCategoriesForSpecialCases(groupFilter, facilityName, 'facility')
    return facilityFilter
}

/**
 * 
 * Filters out the buttons we display under General Information as per business logic rules
 * @param {Array<string>} generalInformationOptions 
 * @param {{id: number, name: string, facilities: {id: number, name: string}}} group 
 * @returns {string[]}
 */
export function filterGeneralInformationOptionsByGroup(generalInformationOptions, group) {
    const filteredGeneralOptions = generalInformationOptions.filter((generalInformationOption) => {
        if (group?.name === 'Vinimark Trading' || group?.name === 'Robertson Winery') {
            const optionsToExclude = ['Plot List', 'Agrochemical List', 'Fertilizer List']
            return !optionsToExclude.includes(generalInformationOption)
        } else return generalInformationOption
    })
    return filteredGeneralOptions
}